import { ApiRequestModel } from "../api_request_model";

export class BaseClass {
  public ConditionalOperator: number;
  public SendApiRequestModel: ApiRequestModel;
}

//export class GenericProcPostReqeust {
//  public QueryData: number;
//}
export class CodeTypesController {
  public Name: string;
  public ShortName: string;
  public AllowHierarchy: boolean;
  public Code: number;
}

export class CredentialTypeRequest extends BaseClass {
  public CredentialTypeCode: number;
  public Name: string;
  public ShortName: string;
  public Group: string;
  public Speciality: string;
  public RenewalType: string;
  public RenewalDurationDays: number;
  public IsCredentialVerifiable: boolean;
}

export class CredentialTypeController{
  public CredentialTypeCode: number;
  public Name: string;
  public ShortName: string;
  public GROUP: string;
  public Speciality: string;
  public RenewalType: string;
  public RenewalTypeLongValue: string;
  public GROUPLongValue: string;
  public RenewalDurationDays: number;
  public IsCredentialVerifiable: boolean;
}


export class ActorRoleDutyRequest extends BaseClass {
  public ActorRoleDutyCode: number;
  public Role: string;
  public Duty: string;
  public ActorType: number;
}

export class ActorRoleDutyController {
  public ActorRoleDutyCode: number;
  public ActorTypeName: string;
  public ActorType: number;
  public Role: string;
  public Duty: string;
  public RoleLongValue: string;
}
export class ActorCredentialConfigRequest extends BaseClass {
  public ActorCredentialConfigCode: number;
  public ActorRoleDutyCode: number;
  public CredentialTypeCode: number;
  public IsMandatory: boolean;
  public IsOnlyOnce: boolean;
  public VerMode: string;
  public FrequencyInDays: number;
}
export class ActorCredentialConfigController {
  public ActorCredentialConfigCode: number;
  public ActorRoleDutyCode: number;
  public Duty: string;
  public ActorRole: string;
  public ActorRoleLongValue: string;
  public CredentialTypeCode: number;
  public CredentialTypeName: string;
  public CredentialTypeShortName: string;
  public CredentialTypeGroup: string;
  public RenewalType: string;
  public RenewalTypeLongValue: string;
  public RenewalDurationDays: number;
  public Speciality: string;
  public IsMandatory: boolean;
  public IsOnlyOnce: boolean;
  public VerMode: string;
  public VerModeLongValue: string;
  public FrequencyInDays: number;
}
export class ModulesRequest extends BaseClass {

}
export class RolesRequest extends BaseClass {

}
export class RolesInfoController {
  public RoleId: string;
  public RoleName: string;
  public Description: string;
}

export class ModulesInfoController {
  public ModuleID: string;
  public ModuleName: string;
  public Description: string;
}
export class RoleFeatureLinkRequest extends BaseClass {
  public ModuleID: string;
  public RoleID: string;
  public ActorCode: number;
  public UserType: number;
  public RoleFeatureLinkInfoControllerList: RoleFeatureLinkInfoController[];
}

export class RoleFeatureLinkInfoController {
  public Code: number;
  //
  public FeatureName: string;
  public FeatureType: string;
  public Description: string;
  //
  public FeatureID: string;
  public RoleID: string;
  public List: boolean;
  public Detail: boolean;
  public Edit: boolean;
  public Report: boolean;
    public Mail: boolean;
    public RoleName: string;
  public Remove: boolean;
}


export class TimeZoneMasterRequest extends BaseClass {

}
export class TimeZoneMasterController {
  public TimeZoneCode: number;
  public Name: string;
  public DisplayName: string;
  public DayLightSavingTime: string;
  public UtcDiff: number;
  public RecordStatus: string;
}
export class CustomCodeValuesController_ {
  public DisplayName: string;
  public SearchName: string;
  public Code: number;
  public Specialty: string;
}

export class CustomCodeTypeRequest_ {
  public RequestedType: string;
  public FacilityCode: number;
  public CodeType: string;
  public ActorCode: number;
  public CustomCode: number;
  public CustomType: string;
  public StringContains: string;
  public SendApiRequestModel: ApiRequestModel;
}
